import { roles } from "../../utils/constants";

interface IUser {
  role: string;
  person: {
    licensee: {
      is_blocked: boolean;
      signature: string;
      completed_onboard: boolean;
      situation: string;
    };
  };
}

class Services {
  async getUserRoleAndRedirect(
    path: string,
    user: IUser,
    user_role: string,
    planHasExpired: boolean,
    isOverdue: boolean
  ) {
    const block_status = user?.person?.licensee?.is_blocked;

    switch (user_role) {
      case roles.licensee:
        if (block_status === true) {
          return "/payment";
        } else if (isOverdue === true) {
          return "/overdue"
        }
        return "/dashboard";
      case roles.admin:
        return "/admin/dashboard";
      case "DISABLED":
        return;
      case roles.fixiter:
        return "/dashboard";
      case roles.creator:
        return "/creators/dashboard";
    }
  }
}

export const services = new Services();
